import {
  DefaultSummary,
  LayoutButtonsCheckout,
  LayoutPaddinCheckout,
} from "@/Components/Index";
import Skeleton from "react-loading-skeleton";

export const DefaultCheckout = () => {
  return (
    <div className="d-flex flex-column">
      <h3 className="develop___text text-center">
        <Skeleton />
      </h3>
      <DefaultSummary />
      <br />
      <br />
      <LayoutButtonsCheckout>
        <LayoutPaddinCheckout>
          <Skeleton className="btn btn-lg" width={200} height={40} />
        </LayoutPaddinCheckout>
        <LayoutPaddinCheckout>
          <Skeleton className="btn btn-lg" width={200} height={40} />
        </LayoutPaddinCheckout>
      </LayoutButtonsCheckout>
    </div>
  );
};
